<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{row}">
        <el-tag
          size="mini"
          :type="
            row.versionStatus === 'P'
              ? 'success'
              : row.versionStatus === 'D'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_versionStatus }}
        </el-tag>
      </template>

      <template v-slot:opt="{row}">
        <div>
          <b-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_tips_view') || '查看'"
              placement="top"
            >
              <i
                class="el-icon-view tool-btn"
                @click="
                  $emit('openEditFormDialog', {
                    type: 'detail',
                    code: row.versionCode,
                  })
                "
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_tips_edit') || '编辑'"
              placement="top"
              v-show="row.versionStatus === 'N'"
              v-if="allow('M')"
            >
              <i
                class="el-icon-edit tool-btn"
                @click="
                  $emit('openEditFormDialog', {
                    type: 'edit',
                    code: row.versionCode,
                  })
                "
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_tips_del') || '删除'"
              placement="top"
              v-show="row.versionStatus === 'N'"
              v-if="allow('D')"
            >
              <i
                class="el-icon-delete tool-btn"
                @click="del(row.versionCode)"
              ></i>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('form_label_versionStatus_P') || '发布'"
              placement="top"
              v-show="row.versionStatus === 'N'"
              v-if="allow('P')"
            >
              <i
                class="el-icon-check tool-btn"
                @click="release(row.versionCode)"
              ></i>
            </el-tooltip>
          </b-button-group>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.sysVersionDelApi({versionCode: code}).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    release(code) {
      this.$confirm(
        this.$l('form_label_modiStatus') || '确认要发布该版本吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.sysVersionModiStatusApi({versionCode: code}).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_operate_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
